import React from 'react';
import { observer } from 'mobx-react';
import { FormField } from '../../../../../../../../../global/form/form-field/form-field';
import { OEToggle } from '../../../../../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../../../../../global/text/text';
import { CustomFieldsOptionsListDTO } from '../../../../../../../../../../api/custom-pages.dao';
import { DefaultPageViewModel } from '../../../default-page.viewmodel';
import { RestrictAccessContainer } from '../../../restrict-access-container';
import { useRestrictAccess } from './restrict-access.hook';

type IProps = {
    pageVm: DefaultPageViewModel;
    organizationTypes: string[];
    customFieldsOptionsList: CustomFieldsOptionsListDTO[];
};

export const RestrictAccessSection = observer(({ pageVm, organizationTypes, customFieldsOptionsList }: IProps): JSX.Element => {
    const { restrictAccess, handleToggleRestrictAccess } = useRestrictAccess(pageVm);

    return (
        <>
            <FormField>
                <div className='website-custom__checkbox-label m-top-15px m-bottom-0px'>
                    <OEToggle
                        isSelected={restrictAccess}
                        onClick={handleToggleRestrictAccess}
                    />
                    {restrictAccess ? (
                        <Text
                            message='Access to Replays page is restricted'
                            id='oe.defaultPage.accessToReplaysRestricted'
                            description='Label text'
                        />
                    ) : (
                        <Text
                            message='Access to Replays page is not restricted'
                            id='oe.defaultPage.accessToReplaysNotRestricted'
                            description='Label text'
                        />
                    )}
                </div>
                <div className='font-size-12px line-height-21px m-top-15px'>
                    <Text
                        message='When access to Replays page is restricted, attendees will only have access to the Replays page
                         if they match all the criteria of at least one filter.'
                        id='oe.defaultPage.accessReplaysDescription'
                        description='Label text'
                    />
                </div>
            </FormField>
            {restrictAccess && (
                <RestrictAccessContainer
                    pageVm={pageVm}
                    organizationTypes={organizationTypes}
                    maxFiltersCount={20}
                    customFieldsOptionsList={customFieldsOptionsList}
                />
            )}
        </>
    );
});